<template>
  <div>
    <seg-carousel
      :item-top="false"
      :height="bannerHeight"
      :modal-shadow="false"
      :imgs="[{'src': require('@/assets/img/cate-page-top-back/gov.png')}]"
      indicator-position="none"
    >
      <template v-slot:modal-layer>
        <pull-down-notice-arrow
          v-if="['GovernmentServiceIndex'].includes($route.name)"
          style="left: calc(50% - 15px);"
        />
      </template>
    </seg-carousel>
    <router-view />
  </div>
</template>

<script>
import SegCarousel from '@/components/indexTopCarousel/segCarousel';
import PullDownNoticeArrow from '@/components/pullDownNoticeArrow/pullDownNoticeArrow';
export default {
  name: 'Index',
  components: {PullDownNoticeArrow, SegCarousel},
  computed: {
    bannerHeight: function() {
      if(!['GovernmentServiceIndex'].includes(this.$route.name)) {
        return '360px'
      }
      return '500px'
    }
  }
}
</script>

<style scoped>

</style>
